import SummarySection from './SummarySection';
import SummarySectionBody from './SummarySectionBody';
import SummarySectionHeader from './SummarySectionHeader';

export {
  SummarySectionBody,
  SummarySectionHeader,
};

export default SummarySection;
